import { render, staticRenderFns } from "./cImageUpload.vue?vue&type=template&id=6ed796fb&scoped=true"
import script from "./cImageUpload.vue?vue&type=script&lang=js"
export * from "./cImageUpload.vue?vue&type=script&lang=js"
import style0 from "./cImageUpload.vue?vue&type=style&index=0&id=6ed796fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed796fb",
  null
  
)

export default component.exports